module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.align === 'left') ? _c('div', {
    staticClass: "row max-height-vertical box-overflow"
  }, [_c('div', {
    ref: "contentCard",
    staticClass: "span-8-lg bg-white relative ind-1 border-left-right-blue overflow-hidden content-card show-md"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "scroll-outer center-flex"
  }, [_c('div', {
    staticClass: "slide-content relative ind-1 content-translate",
    class: _vm.contentActiveClass
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('span-background', {
    attrs: {
      "full": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "span-8-lg relative ind-2 content-translate",
    class: _vm.mediaActiveClass
  }, [(_vm.image) ? _c('div', {
    ref: "overflowCard",
    staticClass: "overflow-image",
    style: (_vm.ratio_styles)
  }, [_c('image-component', {
    attrs: {
      "image": _vm.image
    }
  })], 1) : (_vm.video || _vm.videoFile) ? _c('div', {
    ref: "overflowCard",
    staticClass: "overflow-image",
    style: (_vm.ratio_styles)
  }, [_c('video-component', {
    attrs: {
      "video": _vm.video,
      "videoFile": _vm.videoFile
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "contentCard",
    staticClass: "span-8-lg bg-white relative ind-1 border-left-right-blue overflow-hidden content-card hide-md"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "scroll-outer center-flex"
  }, [_c('div', {
    staticClass: "slide-content relative ind-1 content-translate",
    class: _vm.contentActiveClass
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('span-background', {
    attrs: {
      "full": "true"
    }
  })], 1)]) : _c('div', {
    staticClass: "row max-height-vertical box-overflow"
  }, [_c('div', {
    ref: "contentCard",
    staticClass: "span-8-lg bg-white relative ind-1 border-left-right-blue overflow-hidden content-card"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "scroll-outer center-flex"
  }, [_c('div', {
    staticClass: "slide-content relative ind-1 content-translate",
    class: _vm.contentActiveClass
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('span-background', {
    attrs: {
      "full": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "span-8-lg relative ind-2 content-translate",
    class: _vm.mediaActiveClass
  }, [(_vm.image) ? _c('div', {
    ref: "overflowCard",
    staticClass: "overflow-image overflow-left",
    style: (_vm.ratio_styles)
  }, [_c('image-component', {
    attrs: {
      "image": _vm.image
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.video || _vm.videoFile) ? _c('div', {
    ref: "overflowCard",
    staticClass: "overflow-image overflow-left",
    style: (_vm.ratio_styles)
  }, [_c('video-component', {
    attrs: {
      "video": _vm.video,
      "videoFile": _vm.videoFile
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b7c5176"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/overflow_image_slide.vue
// module id = 620
// module chunks = 1